import { Injectable, Inject } from '@angular/core';
import { ProcessingService as IProcessingService } from '@relevance/core';

import { ProcessingServiceConfig, PROCESSING_CONFIG } from './processing.config';

/**
 * This service exposes the processing service as an Angular dependency.
 */
@Injectable()
export class ProcessingService extends IProcessingService {

  constructor(
    @Inject(PROCESSING_CONFIG) config: ProcessingServiceConfig,
  ) {
    super(config.url);
  }

}
